(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["prescription-note-2"]) return;
  try {
    
$(document).ready(function(){
  $('.popup-modal').magnificPopup({
    type: 'inline',
    midClick: true,
    mainClass: 'mfp-fade',
    fixedContentPos: true,
    callbacks:{
    open:function(){
        $(".mfp-wrap").scroll(function(){
        var scrollTop = $(".mfp-wrap").scrollTop();
        if(scrollTop > 20 ){
          $("div.popup-modal-box .mfp-close").css("top", scrollTop - 20);
        }
        else{
          $("div.popup-modal-box .mfp-close").css("top", '-20px');
        } 
      });
    },
	beforeOpen: function() { $('html').addClass('mfp-helper'); },
    close: function() { $('html').removeClass('mfp-helper'); }
  }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-block"]) return;
  try {
    
  $("#playFVideo").click(function(){
    $('#fVidoe').get(0).play();
    $(this).parents("div.video-holder").addClass('playing').removeClass('pause');
  });

  $("#playYVideo").on("click", function(){
    $(this).parents("div.video-holder").addClass('playing').removeClass('pause');
  });

    $("#pauseYVideo").on("click", function(){
    $(this).parents("div.video-holder").addClass('pause').removeClass('playing');
  });
  $("#pauseFVideo").click(function(){
    $('#fVidoe').get(0).pause();
    $(this).parents("div.video-holder").addClass('pause').removeClass('playing');
  });
  var vid = document.getElementById("fVidoe");
	vid.onended = function() {
	  $("#fVidoe").parents("div.video-holder").removeClass('playing');
	};

    $('.sound-on').click(function(){
        $('.sound-on').fadeOut();
        $('.sound-off').fadeIn();
        $("video").prop('muted', true);
    });

    $('.sound-off').click(function(){
        $('.sound-on').fadeIn();
        $('.sound-off').fadeOut();
        $("video").prop('muted', false);
    });

var videoOs = new OnScreen({
            tolerance: 0,
            debounce: 1,
            container: window,
        });
        videoOs.on('enter', '#fVidoe', (element, event) => {});
        videoOs.on('leave', '#fVidoe', (element, event) => {
            $('#fVidoe').get(0).pause();
            $("#fVidoe").parents("div.video-holder").removeClass('playing');
        });
    

  } catch(e) { console.error(e); }
})();

})();
